const team = {
	name: 'Sachbearbeiter | Ansprechpartner',
	fields: {
		user: 'Sachbearbeiter',
		last_name: 'Name',
		active: 'Aktiv',
		can_delete: 'Löschen',
		can_update: 'Aktualisieren',
		can_post: 'Neuanlage',
		can_settings: 'Einstellungen',
		can_view_all_reports: 'Alle Meldungen Ansehen',
	},
}

export default team
